// Shared UI constants

export const EMOJIS = ['😀', '😊', '😂', '🥰', '😎', '🤔', '👍', '👋', '🤘', '🎉', '❤️', '🔥', '✨', '💯', '🙏', '👏', '🤝', '✅', '❌']
